//import jwtDecode from "jwt-decode";
import http from "./httpService";
import { apiUrl } from "../../config.js";

const apiEndpoint = apiUrl + "/auth/";
const tokenKey = "token";
const expiresInKey = "expiresInKey";
// http.setJwt(getJwt());

export async function login(username, password, keepMeSignIn = false) {
  const response = await http.post(apiEndpoint + "login", {
    username,
    password,
    keepMeSignIn,
  });

  const { token, expiresIn } = response.data;
  localStorage.setItem(tokenKey, token);
  localStorage.setItem(expiresInKey, expiresIn);
  return response;
}

export function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
}

export function logout() {
  localStorage.removeItem(tokenKey);
}

export function logoutUser() {
  return http.post(apiEndpoint + "logout");
}

export function forgotPassword(email) {
  return http.post(apiEndpoint + "forgot-password", email);
}

export function getCurrentUser() {
  try {
    //const jwt = localStorage.getItem(tokenKey);
    //return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
};
